import { useEffect, useRef, useState } from 'preact/hooks';
import { EMOTES, MAX_CHAT_LENGTH } from '../../net/protocol';
import { ui } from '../store';
import { useServices } from '../context';

const VISIBLE_MS = 12_000;

/** Bottom-left chat log, input and emote bar (multiplayer only). */
export function Chat() {
  const { net, audio } = useServices();
  const [text, setText] = useState('');
  const [, setTick] = useState(0);
  const input = useRef<HTMLInputElement>(null);
  const open = ui.chatOpen.value;

  // Re-render periodically so old messages fade out.
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 2000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (open) input.current?.focus();
  }, [open]);

  const now = Date.now();
  const lines = ui.chat.value.filter((line) => open || now - line.time < VISIBLE_MS).slice(-8);

  const submit = (e: Event) => {
    e.preventDefault();
    if (text.trim()) {
      net.sendChat(text);
      audio.play('chat');
    }
    setText('');
    ui.chatOpen.value = false;
    input.current?.blur();
  };

  return (
    <div class={`chat ${open ? 'open' : ''}`}>
      <ul class="chat-log" aria-live="polite">
        {lines.map((line) => (
          <li key={line.id} class={line.system ? 'system' : ''}>
            <b style={{ color: line.color }}>{line.name}</b> {line.text}
          </li>
        ))}
      </ul>
      <form class="chat-form" onSubmit={submit}>
        <input
          ref={input}
          value={text}
          maxLength={MAX_CHAT_LENGTH}
          placeholder="Say hi! (Enter)"
          aria-label="Chat message"
          onInput={(e) => setText((e.target as HTMLInputElement).value)}
          onFocus={() => (ui.chatOpen.value = true)}
          onBlur={() => (ui.chatOpen.value = false)}
          onKeyDown={(e) => {
            if (e.key === 'Escape') (e.target as HTMLInputElement).blur();
          }}
        />
      </form>
      <div class="emotes" role="group" aria-label="Emotes">
        {EMOTES.map((emote) => (
          <button
            key={emote}
            class="emote"
            onClick={() => net.sendEmote(emote)}
            aria-label={`Emote ${emote}`}
          >
            {emote}
          </button>
        ))}
      </div>
    </div>
  );
}
